import { AgGridRequest } from '@/types/models';

export default {
    startRow: 0,
    endRow: 100,
    sortModel: [],
    filterModel: {},
} as AgGridRequest;
